import { extendWithClassNames } from '../../../utils/extendWithClassNames.jsx';
import { TeaserLinkedImage } from '../../ContentTeaserSnippets/ContentTeaserPartials/TeaserLinkedImage.jsx';
import { ultraWideScreenCenterHeroImagesClassName, ultraWideScreenHeroClassName } from '../../../utils/ultraWideCustomCss';

export const TopStoryHeroImage = extendWithClassNames(TeaserLinkedImage)(
  ultraWideScreenHeroClassName,
  ultraWideScreenCenterHeroImagesClassName,
);
